import iContactsBg from "../../assets/icons/contacts-page/contacts-page-bg.svg";
import iContactsStars from "../../assets/icons/contacts-page/contacts-page-stars.png";
import PageTitle from "../../components/common/page-title/page-title";
import ContactsList from "../../components/contacts-page/contacts-list/contacts-list";
import "./contacts-page.sass";

const ContactsPage = () => {
  return (
    <div className="page contacts-page">
      <PageTitle>контакты</PageTitle>

      <ContactsList />

      <img
        src={iContactsBg}
        className="img-absolute contacts-page__bg"
        alt=""
      />

      <img
        src={iContactsStars}
        className="img-absolute contacts-page__stars"
        alt=""
      />
    </div>
  );
};

export default ContactsPage;
